import React from 'react';
import { motion } from 'framer-motion';
import { useInventory } from '../../contexts/InventoryContext';
import { useNavigate } from 'react-router-dom';
import StatsCard from './StatsCard';
import RecentActivity from './RecentActivity';
import LowStockAlert from './LowStockAlert';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPackage, FiTrendingUp, FiDollarSign, FiAlertTriangle } = FiIcons;

const Dashboard = () => {
  const { products, getTotalValue, getLowStockProducts, getRecentActivity } = useInventory();
  const navigate = useNavigate();

  const totalProducts = products.length;
  const totalQuantity = products.reduce((sum, product) => sum + product.quantity, 0);
  const totalValue = getTotalValue();
  const lowStockProducts = getLowStockProducts();
  const recentActivity = getRecentActivity();

  const stats = [
    { title: 'Total Products', value: totalProducts, icon: FiPackage, color: 'blue', onClick: () => navigate('/products') },
    { title: 'Total Quantity', value: totalQuantity, icon: FiTrendingUp, color: 'green' },
    { title: 'Total Value', value: `$${totalValue.toLocaleString()}`, icon: FiDollarSign, color: 'purple' },
    { title: 'Low Stock Items', value: lowStockProducts.length, icon: FiAlertTriangle, color: lowStockProducts.length > 0 ? 'red' : 'gray', onClick: () => navigate('/products') }
  ];

  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">InventraQ Dashboard</h1>
        <p className="text-gray-600 dark:text-gray-400">Overview of your inventory management system</p>
      </motion.div>

      {/* Stats Grid */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5, delay: 0.1 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
      >
        {stats.map((stat, index) => (
          <motion.div 
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 + index * 0.1 }}
          >
            <StatsCard {...stat} />
          </motion.div>
        ))}
      </motion.div>

      {/* Low Stock Alert */}
      {lowStockProducts.length > 0 && (
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <LowStockAlert products={lowStockProducts} />
        </motion.div>
      )}

      {/* Recent Activity */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <RecentActivity activities={recentActivity.slice(0, 10)} />
      </motion.div>
    </div>
  );
};

export default Dashboard;